export default __webpack_public_path__ + "static/media/SignupImg.16b5607d.jpg";